export const SEVERITIES = ["critical", "high", "medium", "low", "unknown"];
export const MAP_STATE_SAVE_DEBOUNCE_MS = 750;
export const DEFAULT_LIMIT_PER_SOURCE = 2000;
export const OPENSKY_AIRCRAFT_SOURCE_ID = "opensky_aircraft";
export const SPACE_SATELLITES_SOURCE_ID = "space_satellites";
export const SPACE_WEATHER_SOURCE_ID = "space_weather_alerts";
export const EIA_GRID_MONITOR_SOURCE_ID = "eia_grid_monitor";
export const ENERGY_POWER_PLANTS_SOURCE_ID = "energy_power_plants";
export const ENERGY_SUBSTATIONS_SOURCE_ID = "energy_substations";
export const ENERGY_TRANSMISSION_LINES_SOURCE_ID = "energy_transmission_lines";
export const TRANSITLAND_ROUTES_SOURCE_ID = "transitland_routes";
export const TRANSITLAND_STOPS_SOURCE_ID = "transitland_stops";
export const TRANSITLAND_DEPARTURES_SOURCE_ID = "transitland_departures";
export const GFW_FIXED_INFRASTRUCTURE_SOURCE_ID = "gfw_fixed_infrastructure";
export const TRANSITLAND_SERVICE_ALERTS_SOURCE_ID =
  "transitland_service_alerts";
export const CYBER_ABUSEIPDB_SOURCE_ID = "cyber_abuseipdb_blacklist";
export const CYBER_OTX_SOURCE_ID = "cyber_otx_pulses";
export const CYBER_URLSCAN_SOURCE_ID = "cyber_urlscan_results";
export const GDELT_CONFLICT_EVENTS_SOURCE_ID = "gdelt_conflict_events";
export const AVIATION_SIGMETS_AIRMETS_SOURCE_ID = "aviation_sigmets_airmets";
export const NOAA_TSUNAMI_ALERTS_SOURCE_ID = "noaa_tsunami_alerts";
export const EMSC_EARTHQUAKES_SOURCE_ID = "emsc_earthquakes";
export const CDC_TRAVEL_HEALTH_NOTICES_SOURCE_ID = "cdc_travel_health_notices";
export const ICG_CRISISWATCH_UPDATES_SOURCE_ID = "icg_crisiswatch_updates";
export const NOAA_NDBC_BUOYS_SOURCE_ID = "noaa_ndbc_buoys";
export const NOAA_PORTS_WATER_LEVELS_SOURCE_ID = "noaa_ports_water_levels";
export const OURAIRPORTS_AIRPORTS_SOURCE_ID = "ourairports_airports";
export const WORLD_PORT_INDEX_SOURCE_ID = "world_port_index";
export const WIKIDATA_EMBASSIES_SOURCE_ID = "wikidata_embassies";
export const OSM_HEALTHCARE_SOURCE_ID = "osm_healthcare";
export const OSM_EMERGENCY_SERVICES_SOURCE_ID = "osm_emergency_services";
export const OSM_SHELTERS_AID_SOURCE_ID = "osm_shelters_aid";
export const OSM_WATER_SANITATION_SOURCE_ID = "osm_water_sanitation";
export const OSM_TRANSPORT_NODES_SOURCE_ID = "osm_transport_nodes";
export const OSM_FUEL_LOGISTICS_SOURCE_ID = "osm_fuel_logistics";
export const OSM_TELECOM_SOURCE_ID = "osm_telecom";
export const OSM_GOVERNMENT_DIPLOMATIC_SOURCE_ID = "osm_government_diplomatic";
export const OSM_SCHOOLS_SOURCE_ID = "osm_schools";
export const OSM_SECURITY_SENSITIVE_SOURCE_ID = "osm_security_sensitive";
export const CYBER_SOURCE_IDS = [
  CYBER_ABUSEIPDB_SOURCE_ID,
  CYBER_OTX_SOURCE_ID,
  CYBER_URLSCAN_SOURCE_ID,
];
export const ENERGY_INFRASTRUCTURE_SOURCE_IDS = [
  EIA_GRID_MONITOR_SOURCE_ID,
  ENERGY_POWER_PLANTS_SOURCE_ID,
  ENERGY_SUBSTATIONS_SOURCE_ID,
  ENERGY_TRANSMISSION_LINES_SOURCE_ID,
];
export const TRANSIT_INFRASTRUCTURE_SOURCE_IDS = [
  TRANSITLAND_ROUTES_SOURCE_ID,
  TRANSITLAND_STOPS_SOURCE_ID,
];
export const MARITIME_INFRASTRUCTURE_SOURCE_IDS = [
  GFW_FIXED_INFRASTRUCTURE_SOURCE_ID,
];
export const AVIATION_INFRASTRUCTURE_SOURCE_IDS = [
  OURAIRPORTS_AIRPORTS_SOURCE_ID,
];
export const DIPLOMATIC_INFRASTRUCTURE_SOURCE_IDS = [
  WIKIDATA_EMBASSIES_SOURCE_ID,
];
export const OSM_INFRASTRUCTURE_SOURCE_IDS = [
  OSM_HEALTHCARE_SOURCE_ID,
  OSM_EMERGENCY_SERVICES_SOURCE_ID,
  OSM_SHELTERS_AID_SOURCE_ID,
  OSM_WATER_SANITATION_SOURCE_ID,
  OSM_TRANSPORT_NODES_SOURCE_ID,
  OSM_FUEL_LOGISTICS_SOURCE_ID,
  OSM_TELECOM_SOURCE_ID,
  OSM_GOVERNMENT_DIPLOMATIC_SOURCE_ID,
  OSM_SCHOOLS_SOURCE_ID,
  OSM_SECURITY_SENSITIVE_SOURCE_ID,
];
export const KEYLESS_INFRASTRUCTURE_SOURCE_IDS = [
  ...AVIATION_INFRASTRUCTURE_SOURCE_IDS,
  WORLD_PORT_INDEX_SOURCE_ID,
  ...DIPLOMATIC_INFRASTRUCTURE_SOURCE_IDS,
  ...OSM_INFRASTRUCTURE_SOURCE_IDS,
];
export const KEYLESS_LIVE_SOURCE_IDS = [
  NOAA_NDBC_BUOYS_SOURCE_ID,
  NOAA_PORTS_WATER_LEVELS_SOURCE_ID,
];
export const KEYLESS_EVENT_SOURCE_IDS = [
  AVIATION_SIGMETS_AIRMETS_SOURCE_ID,
  NOAA_TSUNAMI_ALERTS_SOURCE_ID,
  EMSC_EARTHQUAKES_SOURCE_ID,
  CDC_TRAVEL_HEALTH_NOTICES_SOURCE_ID,
  ICG_CRISISWATCH_UPDATES_SOURCE_ID,
];
export const MAP_ONLY_TIME_RANGE_SOURCE_IDS = [
  OPENSKY_AIRCRAFT_SOURCE_ID,
  SPACE_SATELLITES_SOURCE_ID,
  "openaq_locations",
  "waqi_air_quality",
  "windy_webcams",
  TRANSITLAND_DEPARTURES_SOURCE_ID,
  ...KEYLESS_LIVE_SOURCE_IDS,
  ...ENERGY_INFRASTRUCTURE_SOURCE_IDS,
  ...TRANSIT_INFRASTRUCTURE_SOURCE_IDS,
  ...MARITIME_INFRASTRUCTURE_SOURCE_IDS,
  ...KEYLESS_INFRASTRUCTURE_SOURCE_IDS,
];
// GS feed lanes disabled 2026-08: the bottom-row carousels they fed were removed,
// leaving only the sources-panel count badges as consumers — not worth the payloads
// (recalls alone was ~18.7 MB per map mount; see routes/utils/backfill/AUDIT_FINDINGS.md).
// The fetch code is intact; flip a lane to true to re-enable it.
export const GS_FEED_LANES_ENABLED = {
  flights: false,
  outbreaks: false,
  recalls: false,
};
// Bar controls hidden for this release. A GATE, not a deletion: every
// component, fetch, preset field and stored value stays intact, so flipping a
// value to false restores that control with the value the user left on it.
// While a control is retired its dimension is also DEACTIVATED where the page
// READS it (utils.normalizeSavedMapState for the source groups, the overlays
// read in OsintMapHome) — a hidden control must never leave a live filter
// running, and live feeds must fall back to the server defaults rather than an
// empty set, which would skip the events request altogether. Nothing
// deactivates on the WRITE side: a stored value the retirement overwrote would
// be one the restore can no longer give back.
export const RETIRED_MAP_CONTROLS = {
  liveFeeds: true,
  infrastructure: true,
  overlays: true,
};
export const AIRCRAFT_REFRESH_MS = 15000;
export const AIRCRAFT_HIDDEN_REFRESH_MS = 60000;
export const AIRCRAFT_REFRESH_BACKOFF_MS = [30000, 60000, 120000];
export const AIRCRAFT_TRANSITION_MS = 14000;
export const AIRCRAFT_STALE_AFTER_SECONDS = 45;
export const AIRCRAFT_TRAIL_MAX_POINTS = 8;
export const SATELLITE_REFRESH_MS = 60000;
export const SATELLITE_HIDDEN_REFRESH_MS = 300000;
export const SATELLITE_REFRESH_BACKOFF_MS = [120000, 300000, 600000];
export const SATELLITE_STALE_AFTER_SECONDS = 180;
export const TRANSIT_DEPARTURES_REFRESH_MS = 60000;
export const TRANSIT_DEPARTURES_HIDDEN_REFRESH_MS = 120000;
export const TRANSIT_DEPARTURES_REFRESH_BACKOFF_MS = [120000, 240000, 480000];
export const VEL_BLUE = "#0EA5E9";
export const OVERLAY_DATE_MODES = [
  "latest",
  "today",
  "yesterday",
  "custom",
  "default",
];
export const SOURCE_LIMITS = {
  [OPENSKY_AIRCRAFT_SOURCE_ID]: 1500,
  [SPACE_SATELLITES_SOURCE_ID]: 250,
  [SPACE_WEATHER_SOURCE_ID]: 200,
  [EIA_GRID_MONITOR_SOURCE_ID]: 20,
  [ENERGY_POWER_PLANTS_SOURCE_ID]: 300,
  [ENERGY_SUBSTATIONS_SOURCE_ID]: 300,
  [ENERGY_TRANSMISSION_LINES_SOURCE_ID]: 150,
  [TRANSITLAND_ROUTES_SOURCE_ID]: 150,
  [TRANSITLAND_STOPS_SOURCE_ID]: 500,
  [GFW_FIXED_INFRASTRUCTURE_SOURCE_ID]: 300,
  [TRANSITLAND_DEPARTURES_SOURCE_ID]: 150,
  [TRANSITLAND_SERVICE_ALERTS_SOURCE_ID]: 200,
  [GDELT_CONFLICT_EVENTS_SOURCE_ID]: 300,
  [AVIATION_SIGMETS_AIRMETS_SOURCE_ID]: 200,
  [NOAA_TSUNAMI_ALERTS_SOURCE_ID]: 100,
  [EMSC_EARTHQUAKES_SOURCE_ID]: 300,
  [CDC_TRAVEL_HEALTH_NOTICES_SOURCE_ID]: 100,
  [ICG_CRISISWATCH_UPDATES_SOURCE_ID]: 100,
  [NOAA_NDBC_BUOYS_SOURCE_ID]: 500,
  [NOAA_PORTS_WATER_LEVELS_SOURCE_ID]: 350,
  [OURAIRPORTS_AIRPORTS_SOURCE_ID]: 300,
  [WORLD_PORT_INDEX_SOURCE_ID]: 300,
  [WIKIDATA_EMBASSIES_SOURCE_ID]: 150,
  [OSM_HEALTHCARE_SOURCE_ID]: 300,
  [OSM_EMERGENCY_SERVICES_SOURCE_ID]: 250,
  [OSM_SHELTERS_AID_SOURCE_ID]: 250,
  [OSM_WATER_SANITATION_SOURCE_ID]: 300,
  [OSM_TRANSPORT_NODES_SOURCE_ID]: 300,
  [OSM_FUEL_LOGISTICS_SOURCE_ID]: 300,
  [OSM_TELECOM_SOURCE_ID]: 250,
  [OSM_GOVERNMENT_DIPLOMATIC_SOURCE_ID]: 250,
  [OSM_SCHOOLS_SOURCE_ID]: 300,
  [OSM_SECURITY_SENSITIVE_SOURCE_ID]: 150,
  [CYBER_ABUSEIPDB_SOURCE_ID]: 100,
  [CYBER_OTX_SOURCE_ID]: 100,
  [CYBER_URLSCAN_SOURCE_ID]: 100,
};

export const SOURCE_SETTING_DEFINITIONS = {
  [EIA_GRID_MONITOR_SOURCE_ID]: {
    supportsMinZoom: false,
    density: "medium",
    maxFeatures: { default: 20, min: 5, max: 50, step: 5 },
    presets: {
      low: { maxFeatures: 10 },
      medium: { maxFeatures: 20 },
      high: { maxFeatures: 50 },
    },
  },
  [ENERGY_POWER_PLANTS_SOURCE_ID]: {
    supportsMinZoom: true,
    density: "medium",
    minZoom: { default: 5, min: 2, max: 10 },
    maxFeatures: { default: 300, min: 25, max: 1000, step: 25 },
    presets: {
      low: { minZoom: 6, maxFeatures: 150 },
      medium: { minZoom: 5, maxFeatures: 300 },
      high: { minZoom: 4, maxFeatures: 600 },
    },
  },
  [ENERGY_SUBSTATIONS_SOURCE_ID]: {
    supportsMinZoom: true,
    density: "low",
    minZoom: { default: 8, min: 5, max: 12 },
    maxFeatures: { default: 300, min: 25, max: 1000, step: 25 },
    presets: {
      low: { minZoom: 9, maxFeatures: 150 },
      medium: { minZoom: 8, maxFeatures: 300 },
      high: { minZoom: 7, maxFeatures: 600 },
    },
  },
  [ENERGY_TRANSMISSION_LINES_SOURCE_ID]: {
    supportsMinZoom: true,
    density: "low",
    minZoom: { default: 6, min: 3, max: 11 },
    maxFeatures: { default: 150, min: 25, max: 500, step: 25 },
    presets: {
      low: { minZoom: 7, maxFeatures: 75 },
      medium: { minZoom: 6, maxFeatures: 150 },
      high: { minZoom: 4, maxFeatures: 300 },
    },
  },
  [TRANSITLAND_ROUTES_SOURCE_ID]: {
    supportsMinZoom: true,
    density: "low",
    minZoom: { default: 8, min: 5, max: 12 },
    maxFeatures: { default: 150, min: 25, max: 500, step: 25 },
    presets: {
      low: { minZoom: 9, maxFeatures: 75 },
      medium: { minZoom: 8, maxFeatures: 150 },
      high: { minZoom: 7, maxFeatures: 300 },
    },
  },
  [TRANSITLAND_STOPS_SOURCE_ID]: {
    supportsMinZoom: true,
    density: "low",
    minZoom: { default: 11, min: 8, max: 14 },
    maxFeatures: { default: 500, min: 50, max: 2000, step: 50 },
    presets: {
      low: { minZoom: 12, maxFeatures: 250 },
      medium: { minZoom: 11, maxFeatures: 500 },
      high: { minZoom: 10, maxFeatures: 1000 },
    },
  },
  [GFW_FIXED_INFRASTRUCTURE_SOURCE_ID]: {
    supportsMinZoom: true,
    density: "low",
    minZoom: { default: 4, min: 2, max: 10 },
    maxFeatures: { default: 300, min: 25, max: 1000, step: 25 },
    presets: {
      low: { minZoom: 5, maxFeatures: 150 },
      medium: { minZoom: 4, maxFeatures: 300 },
      high: { minZoom: 3, maxFeatures: 600 },
    },
  },
  [OURAIRPORTS_AIRPORTS_SOURCE_ID]: {
    supportsMinZoom: true,
    density: "medium",
    minZoom: { default: 4, min: 2, max: 10 },
    maxFeatures: { default: 300, min: 25, max: 1500, step: 25 },
    presets: {
      low: { minZoom: 5, maxFeatures: 150 },
      medium: { minZoom: 4, maxFeatures: 300 },
      high: { minZoom: 3, maxFeatures: 750 },
    },
  },
  [WORLD_PORT_INDEX_SOURCE_ID]: {
    supportsMinZoom: true,
    density: "medium",
    minZoom: { default: 5, min: 2, max: 10 },
    maxFeatures: { default: 300, min: 25, max: 1200, step: 25 },
    presets: {
      low: { minZoom: 6, maxFeatures: 150 },
      medium: { minZoom: 5, maxFeatures: 300 },
      high: { minZoom: 4, maxFeatures: 750 },
    },
  },
  [WIKIDATA_EMBASSIES_SOURCE_ID]: {
    supportsMinZoom: true,
    density: "low",
    minZoom: { default: 5, min: 3, max: 12 },
    maxFeatures: { default: 150, min: 25, max: 500, step: 25 },
    presets: {
      low: { minZoom: 6, maxFeatures: 75 },
      medium: { minZoom: 5, maxFeatures: 150 },
      high: { minZoom: 4, maxFeatures: 300 },
    },
  },
  [OSM_HEALTHCARE_SOURCE_ID]: {
    supportsMinZoom: true,
    density: "medium",
    minZoom: { default: 11, min: 8, max: 14 },
    maxFeatures: { default: 300, min: 25, max: 1000, step: 25 },
    presets: {
      low: { minZoom: 12, maxFeatures: 150 },
      medium: { minZoom: 11, maxFeatures: 300 },
      high: { minZoom: 10, maxFeatures: 600 },
    },
  },
  [OSM_EMERGENCY_SERVICES_SOURCE_ID]: {
    supportsMinZoom: true,
    density: "medium",
    minZoom: { default: 12, min: 9, max: 15 },
    maxFeatures: { default: 250, min: 25, max: 750, step: 25 },
    presets: {
      low: { minZoom: 13, maxFeatures: 125 },
      medium: { minZoom: 12, maxFeatures: 250 },
      high: { minZoom: 11, maxFeatures: 500 },
    },
  },
  [OSM_SHELTERS_AID_SOURCE_ID]: {
    supportsMinZoom: true,
    density: "low",
    minZoom: { default: 12, min: 9, max: 15 },
    maxFeatures: { default: 250, min: 25, max: 750, step: 25 },
    presets: {
      low: { minZoom: 13, maxFeatures: 125 },
      medium: { minZoom: 12, maxFeatures: 250 },
      high: { minZoom: 11, maxFeatures: 500 },
    },
  },
  [OSM_WATER_SANITATION_SOURCE_ID]: {
    supportsMinZoom: true,
    density: "medium",
    minZoom: { default: 12, min: 9, max: 15 },
    maxFeatures: { default: 300, min: 25, max: 1000, step: 25 },
    presets: {
      low: { minZoom: 13, maxFeatures: 150 },
      medium: { minZoom: 12, maxFeatures: 300 },
      high: { minZoom: 11, maxFeatures: 600 },
    },
  },
  [OSM_TRANSPORT_NODES_SOURCE_ID]: {
    supportsMinZoom: true,
    density: "medium",
    minZoom: { default: 10, min: 7, max: 14 },
    maxFeatures: { default: 300, min: 25, max: 1000, step: 25 },
    presets: {
      low: { minZoom: 11, maxFeatures: 150 },
      medium: { minZoom: 10, maxFeatures: 300 },
      high: { minZoom: 9, maxFeatures: 600 },
    },
  },
  [OSM_FUEL_LOGISTICS_SOURCE_ID]: {
    supportsMinZoom: true,
    density: "low",
    minZoom: { default: 12, min: 9, max: 15 },
    maxFeatures: { default: 300, min: 25, max: 1000, step: 25 },
    presets: {
      low: { minZoom: 13, maxFeatures: 150 },
      medium: { minZoom: 12, maxFeatures: 300 },
      high: { minZoom: 11, maxFeatures: 600 },
    },
  },
  [OSM_TELECOM_SOURCE_ID]: {
    supportsMinZoom: true,
    density: "low",
    minZoom: { default: 12, min: 9, max: 15 },
    maxFeatures: { default: 250, min: 25, max: 750, step: 25 },
    presets: {
      low: { minZoom: 13, maxFeatures: 125 },
      medium: { minZoom: 12, maxFeatures: 250 },
      high: { minZoom: 11, maxFeatures: 500 },
    },
  },
  [OSM_GOVERNMENT_DIPLOMATIC_SOURCE_ID]: {
    supportsMinZoom: true,
    density: "low",
    minZoom: { default: 12, min: 9, max: 15 },
    maxFeatures: { default: 250, min: 25, max: 750, step: 25 },
    presets: {
      low: { minZoom: 13, maxFeatures: 125 },
      medium: { minZoom: 12, maxFeatures: 250 },
      high: { minZoom: 11, maxFeatures: 500 },
    },
  },
  [OSM_SCHOOLS_SOURCE_ID]: {
    supportsMinZoom: true,
    density: "low",
    minZoom: { default: 13, min: 10, max: 16 },
    maxFeatures: { default: 300, min: 25, max: 1000, step: 25 },
    presets: {
      low: { minZoom: 14, maxFeatures: 150 },
      medium: { minZoom: 13, maxFeatures: 300 },
      high: { minZoom: 12, maxFeatures: 600 },
    },
  },
  [OSM_SECURITY_SENSITIVE_SOURCE_ID]: {
    supportsMinZoom: true,
    density: "low",
    minZoom: { default: 13, min: 10, max: 16 },
    maxFeatures: { default: 150, min: 25, max: 500, step: 25 },
    presets: {
      low: { minZoom: 14, maxFeatures: 75 },
      medium: { minZoom: 13, maxFeatures: 150 },
      high: { minZoom: 12, maxFeatures: 300 },
    },
  },
};

export const RENDERER_MODES = {
  flat: "flat",
  globe: "globe",
};

export const DEFAULT_RENDERER_MODE = RENDERER_MODES.flat;

export const RENDERER_MODE_OPTIONS = [
  { key: RENDERER_MODES.flat, label: "Flat" },
  { key: RENDERER_MODES.globe, label: "Globe" },
];

export const GLOBE_MIN_ALTITUDE = 0.08;
export const GLOBE_MAX_ALTITUDE = 4;

export const DEFAULT_GLOBE_VIEWPORT = {
  lat: 20,
  lng: 0,
  altitude: 1.75,
};

export const TIME_RANGES = [
  { key: "1h", label: "1h", seconds: 60 * 60 },
  { key: "24h", label: "24h", seconds: 24 * 60 * 60 },
  { key: "7d", label: "7d", seconds: 7 * 24 * 60 * 60 },
  { key: "30d", label: "30d", seconds: 30 * 24 * 60 * 60 },
  { key: "all", label: "All", seconds: null },
];

export const severityTheme = {
  critical: "border-rose-400/35 bg-rose-500/15 text-rose-100",
  high: "border-red-400/35 bg-red-500/15 text-red-100",
  medium: "border-amber-400/35 bg-amber-500/15 text-amber-100",
  low: "border-emerald-400/35 bg-emerald-500/15 text-emerald-100",
  unknown: "border-sky-400/25 bg-sky-400/10 text-sky-100",
};

export const severityDotTheme = {
  critical: "bg-rose-400 shadow-[0_0_10px_rgba(251,113,133,0.65)]",
  high: "bg-red-400 shadow-[0_0_10px_rgba(248,113,113,0.65)]",
  medium: "bg-amber-400 shadow-[0_0_10px_rgba(251,191,36,0.65)]",
  low: "bg-emerald-400 shadow-[0_0_10px_rgba(52,211,153,0.65)]",
  unknown: "bg-sky-300 shadow-[0_0_10px_rgba(125,211,252,0.65)]",
};

export const statusTheme = {
  ok: "bg-emerald-400",
  stale: "bg-amber-300",
  error: "bg-rose-400",
};

export const timelineSeverityTheme = {
  critical:
    "border-rose-300/55 bg-rose-500/15 text-rose-200 shadow-[0_0_12px_rgba(251,113,133,0.28)]",
  high: "border-red-300/45 bg-red-500/12 text-red-200 shadow-[0_0_10px_rgba(248,113,113,0.22)]",
  medium:
    "border-amber-300/45 bg-amber-500/12 text-amber-200 shadow-[0_0_10px_rgba(251,191,36,0.2)]",
  low: "border-emerald-300/45 bg-emerald-500/12 text-emerald-200 shadow-[0_0_10px_rgba(52,211,153,0.18)]",
  unknown:
    "border-sky-300/40 bg-sky-400/10 text-sky-200 shadow-[0_0_10px_rgba(125,211,252,0.18)]",
};

export const connectorSeverityColor = {
  critical: "#fb7185",
  high: "#f87171",
  medium: "#fbbf24",
  low: "#34d399",
  unknown: "#7dd3fc",
};

export const TIMELINE_MAX_EVENTS = 180;
export const TIMELINE_MAGNIFY_RADIUS = 12;
export const TIMELINE_MAGNIFY_BOOST = 0.78;
export const TIMELINE_PLAYBACK_DURATION_MS = 16000;
export const timelineFutureTheme =
  "border-slate-500/35 bg-slate-500/10 text-slate-500 shadow-none";

export const OSINT_MAP_HOME_CSS = `
  @keyframes osintConnectorDraw {
    from { stroke-dashoffset: 1; opacity: 0; }
    to { stroke-dashoffset: 0; opacity: 0.85; }
  }
`;
